import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_a1d01cba from 'nuxt_plugin_plugin_a1d01cba' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_gtm_76960b62 from 'nuxt_plugin_gtm_76960b62' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_7faf46e1 from 'nuxt_plugin_cookieuniversalnuxt_7faf46e1' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_apollomodule_38a887f6 from 'nuxt_plugin_apollomodule_38a887f6' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_pluginutils_7fc5ae22 from 'nuxt_plugin_pluginutils_7fc5ae22' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_5b133aed from 'nuxt_plugin_pluginrouting_5b133aed' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_4d2f40bc from 'nuxt_plugin_pluginmain_4d2f40bc' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_67158d8e from 'nuxt_plugin_axios_67158d8e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vlazyload_3295c767 from 'nuxt_plugin_vlazyload_3295c767' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_pluginDelayHydrationclient_6f8b666a from 'nuxt_plugin_pluginDelayHydrationclient_6f8b666a' // Source: ./hydration/pluginDelayHydration.client.mjs (mode: 'client')
import nuxt_plugin_swiperJs_32cba6d1 from 'nuxt_plugin_swiperJs_32cba6d1' // Source: ../plugins/swiperJs.js (mode: 'client')
import nuxt_plugin_perfectScrollbar_20f52d1e from 'nuxt_plugin_perfectScrollbar_20f52d1e' // Source: ../plugins/perfectScrollbar (mode: 'client')
import nuxt_plugin_index_48392f8d from 'nuxt_plugin_index_48392f8d' // Source: ../style/theme/index.css (mode: 'client')
import nuxt_plugin_buildinfo_748ad076 from 'nuxt_plugin_buildinfo_748ad076' // Source: ../plugins/build-info.js (mode: 'all')
import nuxt_plugin_vimeoplayer_c28cd600 from 'nuxt_plugin_vimeoplayer_c28cd600' // Source: ../plugins/vimeo-player (mode: 'client')
import nuxt_plugin_elementuii18n_29fd7ad2 from 'nuxt_plugin_elementuii18n_29fd7ad2' // Source: ../plugins/elementui-i18n (mode: 'all')
import nuxt_plugin_facebooklogin_362a4364 from 'nuxt_plugin_facebooklogin_362a4364' // Source: ../plugins/facebookLogin/facebook-login (mode: 'client')
import nuxt_plugin_googlemap_b596750e from 'nuxt_plugin_googlemap_b596750e' // Source: ../plugins/google-map.js (mode: 'client')
import nuxt_plugin_GoogleAnalytics_347e73a0 from 'nuxt_plugin_GoogleAnalytics_347e73a0' // Source: ../plugins/GoogleAnalytics.js (mode: 'client')
import nuxt_plugin_googlesignin_5001ee00 from 'nuxt_plugin_googlesignin_5001ee00' // Source: ../plugins/google-sign-in.js (mode: 'client')
import nuxt_plugin_facebookpixel_6c0c8fbc from 'nuxt_plugin_facebookpixel_6c0c8fbc' // Source: ../plugins/facebook-pixel.js (mode: 'client')
import nuxt_plugin_recaptcha_4dc33226 from 'nuxt_plugin_recaptcha_4dc33226' // Source: ../plugins/recaptcha.js (mode: 'client')
import nuxt_plugin_http_30dfb839 from 'nuxt_plugin_http_30dfb839' // Source: ../plugins/http.js (mode: 'all')
import nuxt_plugin_xml2json_184f8f7e from 'nuxt_plugin_xml2json_184f8f7e' // Source: ../plugins/xml2json.js (mode: 'all')
import nuxt_plugin_hotjar_607e9cb8 from 'nuxt_plugin_hotjar_607e9cb8' // Source: ../plugins/hotjar (mode: 'client')
import nuxt_plugin_userGuest_8e4b12ae from 'nuxt_plugin_userGuest_8e4b12ae' // Source: ../plugins/app/userGuest (mode: 'client')
import nuxt_plugin_staledatadetector_388bf41f from 'nuxt_plugin_staledatadetector_388bf41f' // Source: ../plugins/stale-data-detector (mode: 'client')
import nuxt_plugin_detectOS_948108cc from 'nuxt_plugin_detectOS_948108cc' // Source: ../plugins/detectOS.js (mode: 'all')
import nuxt_plugin_gtm_5e4639ea from 'nuxt_plugin_gtm_5e4639ea' // Source: ../plugins/gtm (mode: 'all')
import nuxt_plugin_klaviyoinit_d6c189e6 from 'nuxt_plugin_klaviyoinit_d6c189e6' // Source: ../plugins/klaviyo-init.js (mode: 'client')
import nuxt_plugin_auth_d2943652 from 'nuxt_plugin_auth_d2943652' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_pays_360cad6f from 'nuxt_plugin_pays_360cad6f' // Source: ../plugins/app/pays (mode: 'all')
import nuxt_plugin_redirect_368ca365 from 'nuxt_plugin_redirect_368ca365' // Source: ../plugins/redirect.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../plugins/auth.js (mode: 'all')
import nuxt_plugin_inject_5d3a56f2 from 'nuxt_plugin_inject_5d3a56f2' // Source: ../plugins/inject (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"JeanMarcPhilippe","htmlAttrs":{"lang":"de"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"facebook-domain-verification","content":"aehn226dojykhw2lqc4v8btzz8byjf"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"src":"https:\u002F\u002Faccounts.google.com\u002Fgsi\u002Fclient","async":true,"defer":true},{"innerHTML":"\n        (function() {\n          var originalAddEventListener = EventTarget.prototype.addEventListener;\n          EventTarget.prototype.addEventListener = function(type, fn, options) {\n            if (type === 'touchstart' || type === 'touchmove') {\n              if (typeof options === 'boolean') {\n                options = { capture: options, passive: true };\n              } else if (typeof options === 'object' && options.passive === undefined) {\n                options.passive = true;\n              } else if (options === undefined) {\n                options = { passive: true };\n              }\n            }\n            originalAddEventListener.call(this, type, fn, options);\n          };\n        })();\n      ","type":"text\u002Fjavascript","charset":"utf-8"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KRMVCPP')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KRMVCPP&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_a1d01cba === 'function') {
    await nuxt_plugin_plugin_a1d01cba(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_76960b62 === 'function') {
    await nuxt_plugin_gtm_76960b62(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7faf46e1 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7faf46e1(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_38a887f6 === 'function') {
    await nuxt_plugin_apollomodule_38a887f6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_7fc5ae22 === 'function') {
    await nuxt_plugin_pluginutils_7fc5ae22(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_5b133aed === 'function') {
    await nuxt_plugin_pluginrouting_5b133aed(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_4d2f40bc === 'function') {
    await nuxt_plugin_pluginmain_4d2f40bc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_67158d8e === 'function') {
    await nuxt_plugin_axios_67158d8e(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_3295c767 === 'function') {
    await nuxt_plugin_vlazyload_3295c767(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginDelayHydrationclient_6f8b666a === 'function') {
    await nuxt_plugin_pluginDelayHydrationclient_6f8b666a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiperJs_32cba6d1 === 'function') {
    await nuxt_plugin_swiperJs_32cba6d1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_perfectScrollbar_20f52d1e === 'function') {
    await nuxt_plugin_perfectScrollbar_20f52d1e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_48392f8d === 'function') {
    await nuxt_plugin_index_48392f8d(app.context, inject)
  }

  if (typeof nuxt_plugin_buildinfo_748ad076 === 'function') {
    await nuxt_plugin_buildinfo_748ad076(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vimeoplayer_c28cd600 === 'function') {
    await nuxt_plugin_vimeoplayer_c28cd600(app.context, inject)
  }

  if (typeof nuxt_plugin_elementuii18n_29fd7ad2 === 'function') {
    await nuxt_plugin_elementuii18n_29fd7ad2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_facebooklogin_362a4364 === 'function') {
    await nuxt_plugin_facebooklogin_362a4364(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlemap_b596750e === 'function') {
    await nuxt_plugin_googlemap_b596750e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_GoogleAnalytics_347e73a0 === 'function') {
    await nuxt_plugin_GoogleAnalytics_347e73a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlesignin_5001ee00 === 'function') {
    await nuxt_plugin_googlesignin_5001ee00(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_facebookpixel_6c0c8fbc === 'function') {
    await nuxt_plugin_facebookpixel_6c0c8fbc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_recaptcha_4dc33226 === 'function') {
    await nuxt_plugin_recaptcha_4dc33226(app.context, inject)
  }

  if (typeof nuxt_plugin_http_30dfb839 === 'function') {
    await nuxt_plugin_http_30dfb839(app.context, inject)
  }

  if (typeof nuxt_plugin_xml2json_184f8f7e === 'function') {
    await nuxt_plugin_xml2json_184f8f7e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjar_607e9cb8 === 'function') {
    await nuxt_plugin_hotjar_607e9cb8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_userGuest_8e4b12ae === 'function') {
    await nuxt_plugin_userGuest_8e4b12ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_staledatadetector_388bf41f === 'function') {
    await nuxt_plugin_staledatadetector_388bf41f(app.context, inject)
  }

  if (typeof nuxt_plugin_detectOS_948108cc === 'function') {
    await nuxt_plugin_detectOS_948108cc(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_5e4639ea === 'function') {
    await nuxt_plugin_gtm_5e4639ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_klaviyoinit_d6c189e6 === 'function') {
    await nuxt_plugin_klaviyoinit_d6c189e6(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_d2943652 === 'function') {
    await nuxt_plugin_auth_d2943652(app.context, inject)
  }

  if (typeof nuxt_plugin_pays_360cad6f === 'function') {
    await nuxt_plugin_pays_360cad6f(app.context, inject)
  }

  if (typeof nuxt_plugin_redirect_368ca365 === 'function') {
    await nuxt_plugin_redirect_368ca365(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  if (typeof nuxt_plugin_inject_5d3a56f2 === 'function') {
    await nuxt_plugin_inject_5d3a56f2(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
